export const REPORT_RESULTS_TAG = 'reportResults';
export const TAGS = [REPORT_RESULTS_TAG];
